import React from 'react';
import classnames from 'classnames';
import s from './NewContentIndicator.scss';
const NewContentIndicator = ({ className , bottomCircleClassName  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['bottom-circle'], bottomCircleClassName)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['top-circle']
    })));
};
NewContentIndicator.displayName = 'NewContentIndicator';
export default NewContentIndicator;
